import React, { useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProviderWrapper } from "./Components";
import {
  GlobalToasterGenerator,
  Middleware,
  SetGlobalRerender,
} from "./Helper";
import { SwitchRoute } from "./Components/Route/SwitchRoute";
import { AppRoutes } from "./routes/AppRoutes/AppRoute";
import { preventSelectAll } from "./Helper/PreventSelectAll.Helper";
import mixpanel from 'mixpanel-browser';
import { useSelector } from "react-redux";

const App = () => {
  const [render, setRender] = useState(false);
  preventSelectAll();
  SetGlobalRerender(setRender, render);
  const { loginResponse } = useSelector((state) => state.login);

  mixpanel.identify(loginResponse && loginResponse.userId || '')
  mixpanel.people.set({
    '$name': loginResponse && loginResponse.fullName || '',
    '$email': loginResponse && loginResponse.email || '', 'plan':
      'test'
  });

  return (
    <Router>
      <ThemeProviderWrapper>
        <GlobalToasterGenerator />
        <Middleware />
        <SwitchRoute routes={AppRoutes} />
      </ThemeProviderWrapper>
    </Router>
  );
};

export default App;
